// Core
import { takeEvery, all, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';


// Workers
import { 
    fetchNomenclatureCustomNameDetailWorker,
    fetchNomenclatureCustomNameCreateWorker,
    fetchNomenclatureCustomNameDeleteWorker,
    fetchNomenclatureCustomNameEditWorker
 } from './worker';
import {
    fetchNomenclatureCustomNameDetail,
    fetchNomenclatureCustomNameCreate,
    fetchNomenclatureCustomNameDelete,
    fetchNomenclatureCustomNameEdit,
} from '../actions';

function* watchFetchNomenclatureCustomNameDetail(): SagaIterator {
    yield takeEvery(fetchNomenclatureCustomNameDetail.async, fetchNomenclatureCustomNameDetailWorker);
}
function* watchFetchNomenclatureCustomNameCreate(): SagaIterator {
    yield takeEvery(fetchNomenclatureCustomNameCreate.async, fetchNomenclatureCustomNameCreateWorker);
}
function* watchFetchNomenclatureCustomNameEdit(): SagaIterator {
    yield takeEvery(fetchNomenclatureCustomNameEdit.async, fetchNomenclatureCustomNameEditWorker);
}
function* watchFetchNomenclatureCustomNameDelete(): SagaIterator {
    yield takeEvery(fetchNomenclatureCustomNameDelete.async, fetchNomenclatureCustomNameDeleteWorker);
}


export function* watchNomenclatureCustomName(): SagaIterator {
    yield all([
        call(watchFetchNomenclatureCustomNameDetail),
        call(watchFetchNomenclatureCustomNameCreate),
        call(watchFetchNomenclatureCustomNameEdit),
        call(watchFetchNomenclatureCustomNameDelete),
    ]);
}